export const NPS_COLOR_TYPE = {
  default: 0,
  colorScaleColorful: 1,
  colorGrayScale: 2
}
